import { useState, useCallback } from "react";
import { MERMAID_PALETTES, DEFAULT_PALETTE_ID, getPaletteById } from "@/shared/lib/mermaidPalettes";

const STORAGE_KEY = "mermaid_palette";

function loadPaletteId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && MERMAID_PALETTES.some((p) => p.id === stored)) return stored;
  } catch {
    /* ignore */
  }
  return DEFAULT_PALETTE_ID;
}

export function useMermaidPalette() {
  const [paletteId, setPaletteIdState] = useState<string>(loadPaletteId);

  const setPaletteId = useCallback((id: string) => {
    if (!MERMAID_PALETTES.some((p) => p.id === id)) return;
    setPaletteIdState(id);
    localStorage.setItem(STORAGE_KEY, id);
  }, []);

  const palette = getPaletteById(paletteId);

  return {
    paletteId,
    palette,
    setPaletteId,
    palettes: MERMAID_PALETTES,
  };
}
